import React, {useEffect, useState} from 'react';
import {css} from '@emotion/react';

import {Modal, PrimaryButton, SecondaryButton} from '../../components';
import {connect} from 'react-redux';
import * as Actions from '../../store/actions';
import PuffLoader from 'react-spinners/PuffLoader';

function DeleteAppModal({
  apps: {mAppLoading},
  open,
  appId,
  deleteApp,
  setOpen,
}) {
  const [id, setAppId] = useState('');

  const handleDelete = () => {
    if (id) {
      deleteApp(appId, setOpen);
    }
  };

  useEffect(() => {
    setAppId(appId);
  }, [appId]);

  const override = css`
    border-color: #ffffff;
    position: absolute;
    background: transparent;
  `;

  return (
    <Modal
      show={open}
      onClose={setOpen}
      extraModalClasses="max-w-[528px] overflow-y-auto h-fit max-h-[95%] sm:max-h-full rounded-b-none sm:rounded-b-lg absolute bottom-0 sm:relative lookup-modal"
      modalPosition="justify-center sm:justify-end"
      modalTitle="Are you sure?"
    >
      <div>
        <p className="mt-4 text-sm text-left text-body px-6">
          By deleting this App, you are deleting every API calls and
          identifications and verifications done with the App.
        </p>

        <div className="w-full mt-6 px-6 py-[14px] border-[0.5px] flex gap-4 border-transparent border-t-[#EFEFEF]">
          <SecondaryButton
            className="w-[50%] !h-10"
            buttonText="Cancel"
            onClick={() => setOpen(false)}
          />

          <PrimaryButton
            className="w-[50%] !h-10 bg-danger"
            onClick={handleDelete}
            buttonText="Delete"
            loading={mAppLoading}
          />
        </div>
      </div>
    </Modal>
  );
}

export default connect(state => state, Actions)(DeleteAppModal);
